import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { graphql } from 'gatsby';
import { map } from 'lodash/fp';

import type { AnySectionDefinition } from '#components/Section';
import Section from '#components/Section';
import HomePageHero from './index/_homepageHero';
import theme from './index/_indexTheme';
import onScrollAnimate from '../utils/onScrollAnimate';

const HomePage = ({ data }: any) => {
  useEffect(() => {
    onScrollAnimate.register([
      { className: 'flair', distanceToReveal: 300 },
      { className: 'reveal' },
    ]);
  }, []);

  const { heading, sections } = data?.page?.content ?? {};

  return (
    <ThemeProvider theme={theme}>
      <div className="container">
        <HomePageHero
          {...heading}
          alignment="left"
          headline={heading?.title}
          info={heading?.text?.text}
          image={heading?.background?.image}
          animatedImage={heading?.background?.bgAnimatedImage}
          video={heading?.background?.video}
        />

        {map((section: AnySectionDefinition) => (
          <section key={section.id}>
            <Section section={section} />
          </section>
        ), sections)}
      </div>
    </ThemeProvider>
  );
};

export default HomePage;

export { Head } from '#components/Head';

export const query = graphql`
  query homePage($locale: String!) {
    page: contentfulComposePage(
      slug: { eq: "home" }
      node_locale: { eq: $locale }
      ) {
      content {
        ...ContentPageTemplate
      }
      seo {
        ...SEO
        lang: node_locale
      }
    }
    locales: allLocale(filter: {language: {eq: $locale}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
